export const isOnScreen = (elem: HTMLElement, offset = 0, parent?: HTMLElement): boolean => {
  let viewport;

  if (parent) {
    viewport = parent.getBoundingClientRect();
  } else {
    viewport = {
      top: window.pageYOffset + offset,
      left: window.pageXOffset,
      right: null,
      bottom: null
    };
    viewport.right = viewport.left + window.innerWidth;
    viewport.bottom = viewport.top + window.innerHeight;
  }

  const elemBounds = elem.getBoundingClientRect();
  const topCoord = elemBounds.top + window.pageYOffset - offset;
  const leftCoord = elemBounds.left + window.pageXOffset;

  const bounds = {
    top: topCoord,
    left: leftCoord,
    right: leftCoord + elemBounds.width,
    bottom: topCoord + elemBounds.height,
  };

  return !(viewport.bottom < bounds.top || viewport.top > bounds.bottom);
};
